import { GoogleMap, useJsApiLoader } from '@react-google-maps/api'
import { General } from 'common/config/general'
import { mapStyle } from './custom'
import { useEffect, useState } from 'react'

const styles = [
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#eeeeee',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e',
      },
    ],
  },
]

const containerStyle = {
  width: '100%',
  height: '299px',
  marginTop: '48px',
}

const center = {
  lat: 49.83379,
  lng: 23.9796976,
}

const zoom = 14

export const Map = () => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: General.googleApiKey,
  })
  const [map, setMap] = useState<google.maps.Map | null>(null)

  const onUnmount = () => {
    setMap(null)
  }

  useEffect(() => {
    if (map && center) {
      const newMarker = new google.maps.Marker({
        position: center,
        map: map,
      })

      return () => newMarker.setMap(null)
    }
  }, [map])

  return (
    <>
      {isLoaded && (
        <GoogleMap
          mapContainerStyle={containerStyle}
          center={center}
          zoom={zoom}
          onLoad={m => setMap(m)}
          onUnmount={onUnmount}
          options={{
            styles: mapStyle,
            panControl: false,
            zoomControl: false,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
          }}
        />
      )}
    </>
  )
}
